import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=608ff2ab&scoped=true&"
import script from "./Attribute.vue?vue&type=script&lang=ts&"
export * from "./Attribute.vue?vue&type=script&lang=ts&"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=608ff2ab&prod&lang=css&"
import style1 from "./Attribute.vue?vue&type=style&index=1&id=608ff2ab&prod&lang=scss&"
import style2 from "./Attribute.vue?vue&type=style&index=2&id=608ff2ab&prod&scoped=true&lang=css&"
import style3 from "./Attribute.vue?vue&type=style&index=3&id=608ff2ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608ff2ab",
  null
  
)

export default component.exports